let url = (new URL(document.URL));
let host = url.hostname
export const domain = host.replace('gestor.', '')

export const rootUrl = 'https://api.'+domain+'/'
export const apiUrl = 'https://api.'+domain+'/gestor/'
export const SCROLL = 200
export const auth_id = 6
export const auth_secret = 'CXJn6Iz4LXcx4xziJzeJ9HBbfI1nsVEBxAE7IFyC'